module.exports = __webpack_public_path__ + "static/img/error.ddf55382.jpg";